<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="close" v-on:click="close(false)"></div>
      <div class="resultCnt" v-if="result" v-on:click="showDd = false">
        <div class="theResult">
          <h4>Kartu Pos Berhasil Dibuat</h4>
          <p>Bagikan kartu pos kamu dengan klik tombol Bagikan dibawah,
          kamu juga bisa download kartu pos untuk kamu print.</p>
          <div :class="{thePostcard: true, page2: page === 1}">
            <div class="flip-card-inner">
              <div class="flip-card-front"
                :style="{'background-image': `url(${result.frontUrl})`}"></div>
              <div class="flip-card-back"
                :style="{'background-image': `url(${result.backUrl})`}"></div>
            </div>
          </div>
          <div class="resultAction">
            <button class="button btnPrev switch" v-on:click="page = (page === 1) ? 0 : 1">
              Lihat Tampilan
              <span v-if="page == 0">Belakang</span>
              <span v-if="page == 1">Depan</span>
            </button>
            <button class="button btnOk share"
              v-on:click="share">Bagikan</button>
            <div class="button btnOk download"
              v-on:click="downloadPdf">
              Download
              <div class="more" v-on:click.stop="showDd = !showDd"></div>
              <div class="dd" v-if="showDd">
                <li v-on:click.stop="downloadPdf">Download PDF File</li>
                <li v-on:click.stop="downloadPng1">Download PNG Depan</li>
                <li v-on:click.stop="downloadPng2">Download PNG Belakang</li>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ShareDialog ref="shareDialog"/>
    </div>
  </transition>
</template>

<script>
import ShareDialog from '@/components/ShareDialog.vue';

export default {
  name: 'postcardGenerator',
  components: { ShareDialog },
  data() {
    return {
      show: false,
      d: null,
      next: null,
      loading: true,
      result: null,
      page: 0,
      showDd: false,
    };
  },
  methods: {
    open(d, next) {
      this.d = d;
      this.page = 0;
      this.loading = true;
      this.result = null;
      this.showDd = false;
      this.next = next;
      this.show = true;
      this.doSave();
    },
    close(b) {
      this.show = false;
      document.body.classList.remove('hideoverflow');
      if (this.next && typeof this.next === 'function') this.next(b, this.result);
    },
    share() {
      this.$refs.shareDialog.open(this.result.shareUrl, this.result.frontUrl);
    },
    downloadPdf() {
      this.showDd = false;
      const link = document.createElement('a');
      link.setAttribute('download', '');
      link.setAttribute('target', '_blank');
      link.href = this.result.pdfUrl;
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    downloadPng1() {
      this.showDd = false;
      const link = document.createElement('a');
      link.setAttribute('download', '');
      link.setAttribute('target', '_blank');
      link.href = this.result.frontUrl;
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    downloadPng2() {
      this.showDd = false;
      const link = document.createElement('a');
      link.setAttribute('download', '');
      link.setAttribute('target', '_blank');
      link.href = this.result.backUrl;
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    doSave() {
      this.$http.post(this.$config.uri('misc/postcard'), this.d).then((r) => {
        this.loading = false;
        this.result = r.data.data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.modal{
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 9991;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  background-color: rgba(255,255,255,.8);
  background-image: url(../assets/loading-2.svg);
  background-size: 46px auto;
  background-position: center;
  background-repeat: no-repeat;
  .close{
    width: 46px; height: 46px;
    position: absolute;
    right: 20px; top: 20px;
    border-radius: 50%;
    transition: all .3s ease;
    cursor: pointer;
    background-image: url(../assets/close.png);
    background-size: 20px auto;
    background-position: center;
    background-repeat: no-repeat;
    opacity: .7;
    z-index: 3;
    &:hover{
      opacity: 1;
      background-color: #eee;
    }
    @media (max-width: 680px) {
      top: 2px; right: 4px;
    }
  }
  .resultCnt{
    background-color: #fff;
    position: absolute;
    left: 0; top: 0; right: 0; bottom: 0;
    overflow-y: auto;
    .theResult{
      width: 600px;
      position: absolute;
      left: 50%; top: 50%;
      transform: translate(-50%, -50%);
      padding-bottom: 80px;
      text-align: center;
      @media (max-height: 690px) {
        position: static;
        transform: none;
        margin: 0 auto;
        padding: 30px 0;
      }
      @media (max-width: 680px) {
        width: auto;
        position: static;
        transform: none;
        margin-top: 46px;
        padding: 0 16px 40px;
      }
      h4{
        font-size: 30px;
        margin: 0 0 6px;
        @media (max-width: 680px) {
          font-size: 24px;
          margin-bottom: 2px;
        }
      }
      p{
        margin: 0 0 30px;
        @media (max-width: 680px) {
          font-size: 15px;
        }
      }
      .resultAction{
        padding-top: 40px;
        .button{
          padding: 8px 14px;
          border: none;
          border-radius: 3px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all .3s ease;
          display: inline-block;
          position: relative;
          padding-left: 42px;
          outline: 0;
          box-sizing: border-box;
          @media (max-width: 680px) {
            width: 100%;
            margin: 0 0 14px !important;
          }
          &.btnPrev{
            background-color: #eee;
            color: #444;
            &:hover{
              background-color: #d5d5d5;
              box-shadow: 2px 2px 6px rgba(0,0,0,.2);
            }
          }
          &.btnOk{
            background-color: #0b845c;
            color: #fff;
            margin-left: 10px;
            &:hover{
              background-color: #006d49;
              box-shadow: 2px 2px 6px rgba(0,0,0,.2);
            }
          }
          &:before{
            width: 18px;
            position: absolute;
            left: 14px; top: 0; bottom: 0;
            content: "";
            background-position: center;
            background-size: 18px auto;
            background-repeat: no-repeat;
          }
          &.switch{
            &:before{
              opacity: .7;
              background-image: url(../assets/switch-black.png);
            }
          }
          &.share{
            &:before{
              background-image: url(../assets/postcard.png);
            }
          }
          &.download{
            padding-right: 38px;
            &:before{
              background-image: url(../assets/down-arrow-white.png);
            }
            .dd{
              background-color: #fff;
              position: absolute;
              top: 100%; right: 0;
              border: #ddd 1px solid;
              border-radius: 5px;
              padding: 6px 0;
              li{
                list-style: none;
                color: #444;
                white-space: nowrap;
                font-size: 14px;
                text-align: left;
                padding: 8px 20px;
                &:hover{
                  background-color: #f5f5fe;
                  cursor: pointer;
                }
              }
            }
          }
          .more{
            position: absolute;
            width: 24px; top: 0; bottom: 0; right: 0;
            border-left: rgba(0,0,0,.2) 1px solid;
            background-image: url(../assets/arrow-down-white.png);
            background-size: 12px auto;
            background-position: center;
            background-repeat: no-repeat;
            border-radius: 0 3px 3px 0;
            @media (max-width: 680px) {
              width: 40px;
            }
          }
        }
      }
    }
  }
}

.thePostcard{
  background-color: transparent;
  width: 540px;
  height: 380px;
  perspective: 1000px;
  margin: 0 auto;
  @media (max-width: 680px) {
    width: 100%;
    height: 64vw;
  }
  .postcardImgInfo{
    position: absolute;
    left: 7px; bottom: -34px;
    font-size: 14px;
    color: #767676;
  }
  .flip-card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.6s;
    transform-style: preserve-3d;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  }
  &.page2{
    .flip-card-inner {
      transform: rotateY(180deg);
    }
  }
  .flip-card-front, .flip-card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    font-family: 'Roboto Mono', monospace;
  }
  .flip-card-front {
    background-color: #999;
    color: black;
    background-position: center;
    background-size: cover;
  }
  .flip-card-back {
    color: white;
    transform: rotateY(180deg);
    background-position: center;
    background-size: cover;
    background-color: #ddd;
  }
}

</style>
